import { LitElement, html, adoptStyles } from 'lit';
import stylesPromise from './studio-icon.css.mjs';

let resolvedStyles = null;
stylesPromise.then(styles => {
	resolvedStyles = styles;
}).catch(error => {
	console.error('Failed to load icon styles:', error);
});

export class StudioIcon extends LitElement {

  static async getStyles() {
    return await styles;
	}

  static properties = {
    name: { type: String, reflect  : true },
    size: { type: String, reflect  : true },
    color: {type: String, reflect : true },
  };

  constructor() {
    super();
    this.name = '';
    this.size = '1rem';
    this.color = 'inherit';
  }

  connectedCallback() {
		super.connectedCallback();
		// Apply styles dynamically if resolved
		if (resolvedStyles) {
			adoptStyles(this.shadowRoot, [resolvedStyles]);
		} else {
			// Retry applying styles after promise resolves
			stylesPromise.then(styles => {
				adoptStyles(this.shadowRoot, [styles]);
			});
		}
	}

  render() {
    return html`
        <span
            class="icon i-${this.name}"
            style="width: ${this.size};
              height: ${this.size};
              color: ${this.color};"
            aria-hidden="true">
        </span>
    `;
  }
}

customElements.define('studio-icon', StudioIcon);
